import React, { useState, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import './ManageDiscountCategories.scss';

interface DiscountCategory {
  category_id: number;
  category_name: string;
}

interface Category {
  id: number;
  name: string;
}

interface ManageDiscountCategoriesProps {
  currentCategories: DiscountCategory[];
  availableCategories: Category[];
  categoriesToAdd: number[];
  categoriesToRemove: number[];
  onAddCategory: (categoryId: number) => void;
  onRemoveCategory: (categoryId: number) => void;
}

const ManageDiscountCategories: React.FC<ManageDiscountCategoriesProps> = ({
  currentCategories,
  availableCategories,
  categoriesToAdd,
  categoriesToRemove,
  onAddCategory,
  onRemoveCategory
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Get categories not currently in the discount and not already added
  const availableToAdd = useMemo(() => {
    const currentCategoryIds = currentCategories.map(cat => cat.category_id);
    return availableCategories.filter(cat =>
      !currentCategoryIds.includes(cat.id) && !categoriesToAdd.includes(cat.id)
    );
  }, [availableCategories, currentCategories, categoriesToAdd]);

  // Filter available categories based on search
  const filteredAvailableCategories = useMemo(() => {
    if (!searchTerm.trim()) return availableToAdd;
    return availableToAdd.filter(cat =>
      cat.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [availableToAdd, searchTerm]);

  return (
    <div className="manage-discount-categories-simple">
      {/* Search and add section */}
      <div className="add-categories-section">
        <div className="section-header">
          <h4>Agregar Categorías</h4>
          <p className="section-description">
            Busca y selecciona categorías para agregar al descuento
          </p>
        </div>

        <div className="search-bar-container">
          <div className="search-input-wrapper">
            <FaSearch className="search-icon" />
            <Form.Control
              type="text"
              placeholder="Buscar categorías para agregar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            {searchTerm && (
              <button
                className="clear-search"
                onClick={() => setSearchTerm('')}
              >
                ×
              </button>
            )}
          </div>
        </div>

        {/* Available Categories List */}
        {availableToAdd.length === 0 ? (
          <div className="empty-state">
            Todas las categorías ya están incluidas en este descuento
          </div>
        ) : filteredAvailableCategories.length === 0 ? (
          <div className="no-results">
            No se encontraron categorías que coincidan con "{searchTerm}"
          </div>
        ) : (
          <div className="categories-list scrollable">
            {filteredAvailableCategories.map(cat => (
              <div
                key={cat.id}
                className="category-row"
                onClick={() => onAddCategory(cat.id)}
              >
                <input
                  type="checkbox"
                  checked={false}
                  onChange={() => onAddCategory(cat.id)}
                  className="category-checkbox"
                  id={`add-${cat.id}`}
                />
                <label htmlFor={`add-${cat.id}`} className="category-label">
                  {cat.name}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageDiscountCategories;
